import { EntityMetaData } from '../../remotion-types';

/**
 * Effect type definitions
 */
export enum EffectType {
  Zoom = 'zoom'
}

// ------------------ Effect Parameters ------------------

/**
 * Parameters for the Zoom effect
 */
export interface ZoomEffectParams {
  baseScale: number; // Starting scale factor
  toScale: number; // Ending scale factor
  centerX?: number; // Optional zoom center X coordinate (0-1, default: 0.5)
  centerY?: number; // Optional zoom center Y coordinate (0-1, default: 0.5)
}

// ------------------ Base Effect Interface ------------------

/**
 * Base interface for all effects
 */

export interface BaseEffect<T extends EffectType, P> {
  id: string;
  type: T;
  start: number; // Start time in seconds relative to element start
  duration: number; // Duration in seconds
  params: P;
  metadata?: EntityMetaData;
  enabled?: boolean; // Whether the effect is enabled (default: true)
  animationInDuration?: number; // Optional animation duration in seconds
  animationOutDuration?: number; // Optional animation duration in seconds
  animationType?: 'easeInAndOut' | 'linear' | 'bounce'; // Animation easing type (default: 'easeInAndOut')
}

// ------------------ Effect Union Type ------------------

/**
 * Union type representing all possible effects
 */
export type Effect = BaseEffect<EffectType.Zoom, ZoomEffectParams>;

// ------------------ Input Effect Type ------------------
